import cx from 'classnames';
import { Card } from 'govbr.frontend.policy/components';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import styles from './ServiceChannelsBody.module.less';

const messages = defineMessages({
  title: {
    id: 'Channel title',
    defaultMessage: 'Channel title',
  },
});

const getValidChannels = (data) => {
  const { channels = [] } = data;
  return channels.filter(
    (channel) =>
      channel.title?.trim() && channel.icon?.trim() && channel.url?.trim(),
  );
};

// Função auxiliar para verificar se existe conteúdo suficiente para exibir
const hasMinimumContent = (data) => {
  const { title, subtitle } = data;
  const validChannels = getValidChannels(data);

  const hasTitleInfo = title?.trim() || subtitle?.trim();

  return hasTitleInfo && validChannels.length > 0;
};

// Função para montar os itens de exibição, aplicando placeholders no modo edição
const getDisplayItems = (channels, isEditMode, placeholder) => {
  // Função para mapear um item para o formato do Card
  const mapToCard = (item) => ({
    ...item,
    '@id': item.url || item['@id'],
    icone_card: item.icon || '',
  });

  // Função para mapear um item para o formato do Card, com placeholder no modo edição
  const mapToCardWithPlaceholder = (item) => ({
    ...item,
    title: item.title?.trim() ? item.title : placeholder.title,
    icone_card: item.icon?.trim() ? item.icon : placeholder.icone_card,
  });

  const validChannels = getValidChannels({ channels });

  if (!isEditMode) {
    return validChannels.map(mapToCard);
  }

  if (channels?.length === 0) {
    return [placeholder];
  }

  return channels.map(mapToCardWithPlaceholder);
};

const ServiceChannelsBody = (props) => {
  const intl = useIntl();

  const { data, isEditMode } = props;

  const { title, subtitle, channels } = data;

  // Se estiver em modo de edição, sempre mostra o template
  if (!hasMinimumContent(data) && !isEditMode) {
    return null;
  }

  const placeholder = {
    title: intl.formatMessage(messages.title),
    icone_card: 'fa-solid fa-info',
  };

  const items = getDisplayItems(channels, isEditMode, placeholder);

  // Placeholders para título e subtítulo
  const displayTitle = title?.trim();
  const displaySubtitle = subtitle?.trim();

  return (
    <div className="mb-4">
      {(displayTitle || displaySubtitle) && (
        <div className="text-center">
          {displayTitle ? <h2>{displayTitle}</h2> : null}
          {displaySubtitle ? <p>{displaySubtitle}</p> : null}
        </div>
      )}
      <div className="d-flex my-5 justify-content-center justify-content-sm-center">
        <div
          className={cx(
            `d-flex row justify-content-center justify-content-sm-center`,
            styles.grid,
            {
              [styles.gridSix]: items.length === 6,
            },
          )}
        >
          {items.map((item, index) => (
            <div className={styles.wrapper} key={index}>
              <Card isEditMode={isEditMode} item={item} size="lg" primary />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

ServiceChannelsBody.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    channels: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        icon: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
  }),
  isEditMode: PropTypes.bool,
};

export default ServiceChannelsBody;
